import React, {useEffect, useState} from "react";
import {boldTextStyles, mediumTextStyles, regularErrorStyle, regularTextStyles} from "../Style";
import {Container, Form, FormGroup, Row, Spinner} from "react-bootstrap";
import NavigateCarInsurance from "./NavigateCarInsurance";
import PostalAddress from "./PostalAddress";
import {useSearchParams} from "react-router-dom";
import {useCookies} from 'react-cookie';
import Cookies from 'js-cookie';
import ContinueOfflinePopupTFAF2 from "./ContinueOfflinePopupTFAF2";
import TooltipTFAF from "./common/TooltipTFAF";
import DisclaimerPopup from "./DisclaimerPopup";
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";
import {useFeature} from '../hooks/useFeature';

const CarDetails = props => {
  const [continueOfflinePopupShow, setContinueOfflinePopupShow] = useState(false);
  const [loadingModels, setLoadingModels] = useState(false);
  const [loadingAddress, setLoadingAddress] = useState(false);
  const [addressSearchComplete, setAddressSearchComplete] = useState(false);
  const [riskAddressList, setRiskAddressList] = useState({});
  const [showNoAddressBlock, setShowNoAddressBlock] = useState(false);
  const [sumInsuredRange, setSumInsuredRange] = useState('');
  const [regNumber, setRegNumber] = useState('');
  const [uniqueAddressFound, setUniqueAddressFound] = useState(false);
  const [errors, setErrors] = useState({});
  const [searchParams] = useSearchParams();
  const [cookie, setCookie] = useCookies(['jwt-token']);
  const [showFinanceCompanies, setShowFinanceCompanies] = useState(null);
  const financeCompanies = ["2Cheap Cars", "AA Finance", "AGCO Finance Ltd", "Alphera Financial Services", "Alternate Finance Ltd", "ANZ Bank New Zealand Limited", "Aotearoa Credit Finance", "Aqua Cars and Finance", "ASB Bank Limited", "Asset Finance Ltd", "Auckland Finance Ltd", "Auto Finance Direct", "Auto Funds Ltd", "Autofunds Ltd Gore", "Avanti Finance", "Axess Finance/Loan Co", "B & N Cars", "B & N Finance", "Bank of China (New Zealand) Limited", "Bank of New Zealand", "Basecorp Finance Ltd", "Baycorp (NZ) Ltd", "Baywide/Bay Credit/Credit Union", "BEE Finance", "Blackbird Finance Ltd", "Blue Star Finance Ltd", "BMW Financial Services", "Bowater Finance", "Branded Financial Services", "Bridge Finance Christchurch", "Broadlands Finance Ltd", "Camellia Finance", "Capital City Finance Ltd", "Car Finance", "CarLoans", "Cash on Carlyle", "Central Finance Ltd", "China Construction Bank (New Zealand) Limited", "Club Finance", "Clyde Car market/Finance", "Combined Building Society", "Community Financial Services (CFS)", "Cox Investments", "Crediflex NZ Ltd", "Credit Finance", "Credit House Finance", "Credit One", "Custom Auto’s", "Daimler Financial", "Dealer Finance", "Delamare Financial Services Ltd", "Discount Finance", "Dolbak Finance Ltd", "Dorchester", "Double Qik Finance", "Double Ten Ltd", "East Bay Finance", "European Financial Services Ltd", "Ezybid Finance", "Fair City Finance", "Falcon Advances Ltd", "Family Finance", "Fico Finance", "Finance Direct", "Finance Mitsubishi", "Finance Now", "Finance Solutions Canterbury", "Financial Holdings Ltd", "First Credit Union", "Fisher and Paykel Credit Union", "Future Finance", "Gary Bates", "GE Money", "Geneva Finance", "George Masters Motors", "Go Car Finance", "Harmoney", "Harnett & Milne Finance", "Heartland Bank", "Holden Financial Services", "HSBC New Zealand Limited", "I Finance Cars and Loans Ltd", "i-finance", "Industrial and Commercial Bank of China (New Zealand) Ltd", "Instant Finance", "JCM Finance", "John Davidson", "Just Finance", "Kings Finance Ltd", "Kiwi Auto Finance Ltd", "Kiwi Car Loans", "Kiwibank Limited", "Latitude Financial Services", "Loan Co. Ltd", "Mainland Finance Ltd", "MARAC", "Medical Assurance Society Ltd", "Mercedes-Benz Financial Services NZ Ltd", "Merit Cars", "Merit Finance", "Metro Finance", "Mitsubishi Finance", "Money Shop", "Mosgiel Motor Court (MMC)", "Motor Trade Finance Limited", "Mount Vehicle Finance", "Mustang 2008 Limited", "Mutual Home Loans Ltd", "MyFinance", "Napier Building Society", "Nelson Building Society", "New Zealand Ltd", "Nissan Finance Ltd", "Now Finance", "NZ Credit Union South", "NZ Money", "NZ Motor Finance", "NZ Vehicle Finance", "NZACU", "NZCU", "NZCU Baywide", "NZCU South Ltd", "On Road Finance", "ORIX New Zealand Ltd", "Other (Not Listed)", "Oxford Finance", "Pacific Loans Ltd", "Partners Finance & Lease", "Pearce Brothers", "Personal Finance Ltd", "PGG Wrightson Finance Ltd", "Pioneer Finance", "Porirua Motors Finance", "Prometheus Finance Ltd", "Pronto Finance Ltd", "Pronto Finance Nelson", "Quickcash Blenheim", "Real Finance Ltd", "Rent Plus", "SBS Bank (Southland Building Society)", "Simplify", "Sky Auto Finance Ltd", "South Canterbury Finance", "South Island Vehicle Finance", "South Pacific Loans", "Southern Cross Building Society", "Southern Finance", "Southland Finance", "Stadium Finance", "Steelsands Credit Union", "Sumita Finance", "The Co-Operative Bank", "The Co-Operative Bank (PSIS)", "The Lending People", "Thorn Group Financial Services", "Toyota Finance", "Treanne Holdings Ltd", "TSB Bank Limited", "Turners", "UDC Finance Limited", "United Credit Union", "Vantage Capital Finance", "Venus Finance Ltd", "Wairarapa Building Society", "Wanganui Finance Ltd", "We Care Finance", "Westforce Credit Union", "Westpac New Zealand Limited", "Yes Finance", "White Rock Finance", "Yamaha Motor Finance NZ Ltd"
  ];
  const [loading, setLoading] = useState(false);
  const [registrationNumber, setRegistrationNumber] = useState('');
  const nztaUnavailable = useFeature('nztaUnavaiable');
  const [isFocused, setIsFocused] = useState(false);
  let url = process.env.REACT_APP_MODE !== null && process.env.REACT_APP_MODE !== undefined && process.env.REACT_APP_MODE.includes('dev') ? 'http://localhost:8080/edge' : '/edge';
  const [urlSource, setURLSource] = useState();
  const [returnUser, setReturnUser] = useState(false);
  const [quoteNum, setQuoteNum] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [declarationPopupShow, setDeclarationPopupShow] = useState(props.inputValues.showDisclaimer);
  const {executeRecaptcha} = useGoogleReCaptcha();
  const [displayDisclosure, setDisplayDisclosure] = useState(true);
  const [modelList, setModelList] = useState([]);
  const [vehicleKey, setVehicleKey] = useState('');
  const [verificationFailedStep, setVerificationFailedStep] = useState([]);
  const [localRiskAddress, setLocalRiskAddress] = useState(null);
  const [addressParams, setAddressParams] = useState(null);
  const [vehicleLookupParam, setVehicleLookupParam] = useState(null);
  const baseUrl = window.location.origin;
  const eventName = window.location.href.includes('car')
    ? 'carAutosureEvent'
    : window.location.href.includes('quashed')
      ? 'carQuashedEvent'
      : window.location.href.includes('better')
        ? 'carBetterEvent'
        : window.location.href.includes('simplify')
          ? 'carSimplifyEvent'
          : '';
  const financeCompanyCodes = {
    "2Cheap Cars": "CHC",
    "AA Finance": "AAF",
    "AGCO Finance Ltd": "AFL",
    "Alphera Financial Services": "AFLS",
    "Alternate Finance Ltd": "ALFS",
    "ANZ Bank New Zealand Limited": "ABNZ",
    "Aotearoa Credit Finance": "AOCF",
    "Aqua Cars and Finance": "ACF",
    "ASB Bank Limited": "ABL",
    "Asset Finance Ltd": "ASFL",
    "Auckland Finance Ltd": "AUFL",
    "Auto Finance Direct": "AFD",
    "Auto Funds Ltd": "ATFL",
    "Autofunds Ltd Gore": "ALG",
    "Avanti Finance": "AVF",
    "Axess Finance/Loan Co": "AFLC",
    "B & N Cars": "BNC",
    "B & N Finance": "BNF",
    "Bank of China (New Zealand) Limited": "BNCH",
    "Bank of New Zealand": "BNZ",
    "Basecorp Finance Ltd": "BCF",
    "Baycorp (NZ) Ltd": "BAYC",
    "Baywide/Bay Credit/Credit Union": "BBCU",
    "BEE Finance": "BEEF",
    "Blackbird Finance Ltd": "BFL",
    "Blue Star Finance Ltd": "BSFL",
    "BMW Financial Services": "BFS",
    "Bowater Finance": "BOWF",
    "Branded Financial Services": "BRF",
    "Bridge Finance Christchurch": "BFC",
    "Broadlands Finance Ltd": "BRFL",
    "Camellia Finance": "CAF",
    "Capital City Finance Ltd": "CAFL",
    "Car Finance": "CARF",
    "CarLoans": "CARL",
    "Cash on Carlyle": "CAOC",
    "Central Finance Ltd": "CFN",
    "China Construction Bank (New Zealand) Limited": "CHBN",
    "Club Finance": "CLF",
    "Clyde Car market/Finance": "CLCF",
    "Combined Building Society": "CBS",
    "Community Financial Services (CFS)": "CFS",
    "Cox Investments": "CXI",
    "Crediflex NZ Ltd": "CNZL",
    "Credit Finance": "CRFN",
    "Credit House Finance": "CHF",
    "Credit One": "CONE",
    "Custom Auto's": "CUA",
    "Daimler Financial": "DFN",
    "Dealer Finance": "DFA",
    "Delamare Financial Services Ltd": "DFSL",
    "Discount Finance": "DIF",
    "Dolbak Finance Ltd": "DFL",
    "Dorchester": "DOR",
    "Double Qik Finance": "DQF",
    "Double Ten Ltd": "DOTL",
    "East Bay Finance": "EBF",
    "European Financial Services Ltd": "EFSL",
    "Ezybid Finance": "EZF",
    "Fair City Finance": "FCF",
    "Falcon Advances Ltd": "FAL",
    "Family Finance": "FFI",
    "Fico Finance": "FIF",
    "Finance Direct": "FID",
    "Finance Mitsubishi": "FIM",
    "Finance Now": "FNW",
    "Finance Solutions Canterbury": "FSC",
    "Financial Holdings Ltd": "FHL",
    "First Credit Union": "FCU",
    "Fisher and Paykel Credit Union": "FPCU",
    "Future Finance": "FUFI",
    "Gary Bates": "GAB",
    "GE Money": "GEMO",
    "Geneva Finance": "GEF",
    "George Masters Motors": "GMM",
    "Go Car Finance": "GCF",
    "Harmoney": "HAR",
    "Harnett & Milne Finance": "HMF",
    "Heartland Bank": "HBNK",
    "Holden Financial Services": "HFS",
    "HSBC New Zealand Limited": "HNZL",
    "I Finance Cars and Loans Ltd": "IFC",
    "i-finance": "IFN",
    "Industrial and Commercial Bank of China (New Zealand) Ltd": "ICBC",
    "Instant Finance": "INFN",
    "JCM Finance": "JCMF",
    "John Davidson": "JOD",
    "Just Finance": "JUF",
    "Kings Finance Ltd": "KIF",
    "Kiwi Auto Finance Ltd": "KAFL",
    "Kiwi Car Loans": "KCL",
    "Kiwibank Limited": "KWBL",
    "Latitude Financial Services": "LFS",
    "Limelight Financial Services Limited": "LME",
    "Loan Co. Ltd": "LCL",
    "Mainland Finance Ltd": "MFL",
    "MARAC": "MRAC",
    "Medical Assurance Society Ltd": "MASL",
    "Mercedes-Benz Financial Services NZ Ltd": "MFSL",
    "Merit Cars": "MC",
    "Merit Finance": "MEF",
    "Metro Finance": "METF",
    "Mitsubishi Finance": "MIF",
    "Money Shop": "MOS",
    "Mosgiel Motor Court (MMC)": "MMC",
    "Motor Trade Finance Limited": "MTFL",
    "Mount Vehicle Finance": "MVFE",
    "Mustang 2008 Limited": "MLTD",
    "Mutual Home Loans Ltd": "MHL",
    "MyFinance": "MYF",
    "Napier Building Society": "NABS",
    "Nelson Building Society": "NEBS",
    "New Zealand Ltd": "NZLT",
    "Nissan Finance Ltd": "NIF",
    "Now Finance": "NOWF",
    "NZ Credit Union South": "NCUS",
    "NZ Money": "NZM",
    "NZ Motor Finance": "NZMF",
    "NZ Vehicle Finance": "NZVF",
    "NZACU": "NZAC",
    "NZCU": "NZCU",
    "NZCU Baywide": "NCUB",
    "NZCU South Ltd": "BCUS",
    "On Road Finance": "ORF",
    "ORIX New Zealand Ltd": "ORIX",
    "Other (Not Listed)": "OTHR",
    "Oxford Finance": "OXFN",
    "Pacific Loans Ltd": "PLL",
    "Partners Finance & Lease": "PFAL",
    "Pearce Brothers": "PEB",
    "Personal Finance Ltd": "PEF",
    "PGG Wrightson Finance Ltd": "PGGW",
    "Pioneer Finance": "PIF",
    "Porirua Motors Finance": "PMF",
    "Prometheus Finance Ltd": "PRFL",
    "Pronto Finance Ltd": "PFL",
    "Pronto Finance Nelson": "PFN",
    "Quickcash Blenheim": "QCB",
    "Real Finance Ltd": "RFL",
    "Rent Plus": "RPLU",
    "SBS Bank (Southland Building Society)": "SBS",
    "Simplify": "SIM",
    "Sky Auto Finance Ltd": "SAFL",
    "South Canterbury Finance": "SCF",
    "South Island Vehicle Finance": "SIVF",
    "South Pacific Loans": "SOPL",
    "Southern Cross Building Society": "SCBS",
    "Southern Finance": "SOF",
    "Southland Finance": "SOLF",
    "Stadium Finance": "STFN",
    "Steelsands Credit Union": "SCU",
    "Sumita Finance": "SUF",
    "The Co-Operative Bank": "TCOP",
    "The Co-Operative Bank (PSIS)": "PSIS",
    "The Lending People": "TLP",
    "Thorn Group Financial Services": "TGFS",
    "Toyota Finance": "TOYF",
    "Treanne Holdings Ltd": "THL",
    "TSB Bank Limited": "TSBL",
    "Turners": "TUR",
    "UDC Finance Limited": "UDCF",
    "United Credit Union": "UCU",
    "Vantage Capital Finance": "VCF",
    "Venus Finance Ltd": "VFL",
    "Wairarapa Building Society": "WBS",
    "Wanganui Finance Ltd": "WFL",
    "We Care Finance": "WCF",
    "Westforce Credit Union": "WCU",
    "Westpac New Zealand Limited": "WNZL",
    "White Rock Finance": "WRF",
    "Yamaha Motor Finance NZ Ltd": "YMFL",
    "Yes Finance": "YEF"
  };
  useEffect(() => {
    if (verificationFailedStep.includes('createProspect')) {
      createProspect();
      setVerificationFailedStep(prev => prev.filter(item => item !== "createProspect"));
    }
    if (verificationFailedStep.includes('vehicleLookup')) {
      vehicleLookup(vehicleLookupParam.regNumber, vehicleLookupParam.transmissionType)
      setVerificationFailedStep(prev => prev.filter(item => item !== "vehicleLookup"));
    }
    if (verificationFailedStep.includes('vehicleSumInsured')) {
      vehicleSumInsured(vehicleKey);
      setVerificationFailedStep(prev => prev.filter(item => item !== "vehicleSumInsured"));
    }
    if (verificationFailedStep.includes('callAddressSearch')) {
      callAddressSearch(addressParams.addressLine1, addressParams.addressLine2, addressParams.suburb, addressParams.postCode, addressParams.nonUniqueAddress);
      setVerificationFailedStep(prev => prev.filter(item => item !== "callAddressSearch"));
    }
    if (verificationFailedStep.includes('handleNextButtonClick')) {
      handleNextButtonClick();
      setVerificationFailedStep(prev => prev.filter(item => item !== "handleNextButtonClick"));
    }
  }, [props.inputValues.isRecaptchaV2Verified]);

  useEffect(() => {
    // Track the 'page loaded' event
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': `${eventName}`,
        'category': 'Page View',
        'virtualUrl': `${baseUrl}/vehicle/step1`,
        'pageTitle': 'Car',
      });
    if (!executeRecaptcha) return;
    let quoteId = Cookies.get('quote-id');
    setQuoteNum(quoteId);

    let token = searchParams.get("token");
    let renewalId = searchParams.get("id");
    let partnerId = searchParams.get("partnerId");

    var details = {
      'user_id': renewalId, 'password': token,
    };
    //let jwt = Cookies.get('jwt-token');
    if (token == null) {
      return;
    }
    if (props.inputValues.id && props.inputValues.id.trim() !== '') {
      return;
    }
    var formBody = "?";
    for (var property in details) {
      var encodedKey = encodeURIComponent(property);
      var encodedValue = encodeURIComponent(details[property]);
      formBody += (encodedKey + "=" + encodedValue + '&');
    }
    fetch(url + '/login' + formBody, {

      method: 'POST', mode: "cors", headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }, body: formBody
    })
      .then((response) => {

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        response.json().then((json) => {
          setCookie('jwt-token', json.JWT, {
            path: '/'
          });
          let jwt = Cookies.get('jwt-token');
          if (partnerId) {
            setReturnUser(false);
            getVehicleDetails(jwt, renewalId, quoteId);
          } else if (quoteId) {
            setReturnUser(false);
            getVehicleDetails(jwt, renewalId, quoteId);
          } else {
            setReturnUser(true);
            setDisplayDisclosure(false);
          }
        });
      })
      .catch((err) => {
        console.error("Caught error: ", err);
        window.location.href = '/page-not-found';
      });
    if (props.inputValues.regNumber && props.inputValues.regNumber.trim() !== '') {
      createProspect();
    }
    setLoadingModels(false);
  }, [executeRecaptcha]);

  useEffect(() => {
    if (!executeRecaptcha) return;
    const selectedVariant = modelList.find(variant => variant.vehicleKey === vehicleKey);
    const model = selectedVariant ? selectedVariant.vehicleDescription : '';
    props.handleChangeValue("vehicleModel", model);
  }, [modelList, vehicleKey]);

  const camelize = (str) => {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toUpperCase() : word.toLowerCase();
    }).replace(/\s+/g, '');
  }
  const handleNextButtonClick = async () => {
    setErrors({});
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      // Scroll to the first error
      const firstErrorKey = Object.keys(newErrors)[0];
      const errorElement = document.getElementsByName(firstErrorKey)[0];
      if (errorElement) {
        errorElement.scrollIntoView({behavior: 'smooth', block: 'center'});
      }
      setErrors(newErrors);

      window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': `${eventName}`,
          'category': 'Submit',
          'status': 'Fail',
          'virtualUrl': `${baseUrl}/vehicle/step1`,
          'pageTitle': 'Car',
        });

    } else if (!isSubmitting) {
      setIsSubmitting(true);
      // Creating vehicleDetails object
      const vehicleDetails = {
        transmission: props.inputValues.transmissionType,
        vehicleKey: props.inputValues.vehicleKey,
        model: props.inputValues.vehicleModel,
        value: props.inputValues.vehicleValue,
        financeCompany: props.inputValues.financeCompany,
        isFinanced: props.inputValues.isFinanced
      };


      // Creating addressInBrokenDownForm object
      const addressInBrokenDownForm = {
        buildingName: props.inputValues.riskBuildingName,
        levelNumber: props.inputValues.riskLevelNumber,
        levelType: props.inputValues.riskLevelType,
        streetName: props.inputValues.riskStreetName,
        streetNumber: props.inputValues.riskStreetNumber,
        streetSuffixCode: props.inputValues.riskStreetSuffixCode,
        streetType: props.inputValues.riskStreetType,
        unitNumber: props.inputValues.riskUnitNumber,
        unitType: props.inputValues.riskUnitType,
      };
      // Creating addressInFreeForm object
      const addressInFreeForm = {
        addressLine1: props.inputValues.riskAddressLine1,
        addressLine2: props.inputValues.riskAddressLine2,
      };

      // Creating risk addressDetails object
      const addressDetails = {
        addressId: props.inputValues.riskAddressId,
        postcode: props.inputValues.riskPostcode,
        suburb: props.inputValues.riskSuburb,
        signature: props.inputValues.riskSignature,
        addressInBrokenDownForm: addressInBrokenDownForm,
        addressInFreeForm: addressInFreeForm,
        type: "RISK"
      };
      if (!executeRecaptcha) {
        console.log('reCAPTCHA is not ready');
        return;
      }
      let token = await executeRecaptcha('submit');
      if (props.inputValues.isRecaptchaV2Verified) {
        token = "AUTHENTICATED_V2"
      }
      let jwt = Cookies.get('jwt-token');
      if (!jwt) {
        window.location.href = `/error-occurred`;
      }
      fetch(url + '/vero/quote/create', {

        method: "POST",
        mode: "cors",
        headers: new Headers({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${jwt}`
        }),
        body: JSON.stringify(
          {
            id: props.inputValues.id,
            vehicleDetails: vehicleDetails,
            addressDetails: addressDetails,
            "recaptchaResponse": token
          }
          // {"attributes":{"coverages":[{"compensations":[{"appliedIndicator":true,"compensationSubType":"AgreedValue","compensationType":"SumInsured","value":15000},{"appliedIndicator":true,"compensationSubType":"MarketValue","compensationType":"SumInsured","value":15000},{"appliedIndicator":false,"compensationSubType":"WindscreenExcessWaiver","compensationType":"CoverType"},{"appliedIndicator":true,"code":"HIRE_CAR_NOT_TAKEN","compensationSubType":"HireCar","compensationType":"CoverType"},{"appliedIndicator":true,"code":"NOT_ELIGIBLE","compensationSubType":"LifetimeNewForOld","compensationType":"CoverType"},{"appliedIndicator":false,"compensationSubType":"RoadsideAssist","compensationType":"CoverType"}],"policyCoverType":"COMPREHENSIVE","risk":{"addressDetails":{"addressId":"lUehd0gPgdL7FOGHQupuXBROntGLNm6wj66a0SsavQaXsKAYqpnZV9askzSBR8TE","addressInBrokenDownForm":{"streetName":"MANUKAU","streetNumber":"100","streetType":"RD"},"addressInFreeForm":{"addressLine1":"100 Manukau Rd"},"postcode":"1023","signature":"4TTiwKhzTf8t/twBDXACcZ/MnbZ3SszWCAQgu27b6xg=","suburb":"EPSOM"},"vehicleRisk":{"accessoriesIndicator":false,"additionalDrivers":[],"damagedIndicator":false,"financeIndicator":false,"mainDriver":{"claimHistory":[],"dateOfBirth":"1990-11-11"},"modificationIndicator":false,"vehicleKey":"0ATnSOMvvQ/q8WHUdGGSmQ==","vehicleUsageType":"PRIVATE"}},"voluntaryExcess":300}],"quoteRequestDetails":{"frequency":"FORTNIGHTLY","policyExpiryDate":"2025-03-27","policyInceptionDate":"2024-03-27","previousInsurer":"NONE"}},"type":"string"}

        )
      })
        .then(response => {
          if (response.status === 428) {
            // Show fallback captcha for 428 status
            console.log('Primary reCAPTCHA failed for handleNextButtonClick, showing fallback captcha');
            //setIsSubmitting(false);
            props.handleChangeValue("showRecaptchaPopup", true);
            setVerificationFailedStep(prev => [...prev, "handleNextButtonClick"]);
            return;
          }
          if (!response.ok) {
            window.location.href = `/error-occurred`;
          } else {
            window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                'event': `${eventName}`,
                'category': 'Submit',
                'status': 'Success',
                'virtualUrl': `${baseUrl}/vehicle/step1`,
                'pageTitle': 'Car',
              });
            props.nextStep();
          }
        })
        .catch(error => {
          console.log('Error:', error);
          window.location.href = `/error-occurred`;
        });
    }
  }
  const findFormErrors = () => {
    const newErrors = {}
    if (!props.inputValues.transmissionType || props.inputValues.transmissionType === '') {
      newErrors.transmissionType = "Please select transmission"
    } else if (!props.inputValues.vehicleKey || props.inputValues.vehicleKey === '') {
      newErrors.vehicleKey = "Please select model"
    }
    if (props.inputValues.businessUse === null) {
      newErrors.businessUse = "Please select ‘Yes’ or ‘No’"
    }
    if (props.inputValues.modification === null) {
      newErrors.modification = "Please select ‘Yes’ or ‘No’"
    }
    if (props.inputValues.isFinanced === null) {
      newErrors.isFinanced = "Please select ‘Yes’ or ‘No’"
    }
    if (props.inputValues.isFinanced === "YES" && (!props.inputValues.financeCompany || props.inputValues.financeCompany === "" || props.inputValues.financeCompany === "on")) {
      newErrors.financeCompany = "Please select finance company’"
    }
    if (!props.inputValues.vehicleValue || props.inputValues.vehicleValue === '') {
      newErrors.vehicleValue = "Please enter car's value"
    } else {
      // Check if the value is a valid whole number
      const isValidWholeNumber = /^\d+$/.test(props.inputValues.vehicleValue);

      if (!isValidWholeNumber) {
        newErrors.vehicleValue = "Please enter valid car's value";
      } else if (props.inputValues.vehicleValue < props.inputValues.vehicleMinValue || props.inputValues.vehicleValue > props.inputValues.vehicleMaxValue) {
        newErrors.vehicleValue = "We would expect your car’s value to be between $" + props.inputValues.vehicleMinValue.toLocaleString() + " and $" + props.inputValues.vehicleMaxValue.toLocaleString();

        window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': `${eventName}`,
            'category': 'Car Value',
            'status': 'Fail',
            'virtualUrl': `${baseUrl}/vehicle/step1`,
            'pageTitle': 'Car',
          });
      } else if (props.inputValues.vehicleValue > 150000) {
        newErrors.vehicleValue = "Sorry, We are unable to offer insurance for your car";
      }
    }

    if (!props.inputValues.full_address || props.inputValues.full_address === '') {
      newErrors.address = "Please enter address";
    } else if (!props.inputValues.uniqueAddressFound) {
      newErrors.address = "Address not found"
    }
    return newErrors;
  }

  const steps = [// {name: 'Step 1', status: 'complete'},
    {name: 'Step 1', status: 'current', desc: 'Car'}, {
      name: 'Step 2',
      status: 'upcoming',
      desc: 'Driver'
    }, {name: 'Step 3', status: 'upcoming', desc: 'Quote'}, {
      name: 'Step 4',
      status: 'upcoming',
      desc: 'Policyholder'
    }, {name: 'Step 5', status: 'upcoming', desc: 'Payment'},];

  const handleFinanceOption = (e) => {
    if (e.target.id === "financedYes") {
      setShowFinanceCompanies(true);
      props.handleChangeValue("financeCompany", e.target.value);
    } else {
      setShowFinanceCompanies(false);
      props.handleChangeValue("financeCompany", '');
    }
  };
  const formatDate = (dateString) => {
    const [day, month, year] = dateString.split('/');
    return `${year}-${month}-${day}`;
  }
  const mapIncidentList = (driver) => {
    const incidents = {};

    for (let i = 0; i < 4; i++) {
      const issueKey = `issue${i + 1}`;
      const monthKey = `month${i + 1}`;
      const yearKey = `year${i + 1}`;

      incidents[`incidents${i + 1}`] = {
        claimCode: driver[issueKey] || '',
        claimMonth: driver[monthKey] || '',
        claimYear: driver[yearKey] || ''
      };
    }
    return incidents;
  };

  const getVehicleDetails = async (jwt, renewalId, quoteId) => {
    props.handleChangeValue("id", renewalId);
    if (!executeRecaptcha) {
      console.log('reCAPTCHA is not ready');
      return;
    }
    let token = await executeRecaptcha('submit');
    if (props.inputValues.isRecaptchaV2Verified) {
      token = "AUTHENTICATED_V2"
    }

    fetch(url + '/vero/prospect/car?id=' + encodeURIComponent(renewalId) +  '&quoteNum=' + quoteId, {

      method: "GET", mode: "cors",

      headers: new Headers({
        Accept: "application/json", "Authorization": `Bearer ${jwt}`, "captchaRequest": token
      }),
    })
      .then((response) => {
        if (response.status === 204 || response.status === 0 || response.body === null) {
          setReturnUser(true);
          return;
        }
        response.json().then(async (json) => {
          // console.log("response.json()response.json()", json)
          if (quoteNum && quoteNum.trim() === json.quoteId) {
            setErrors({});
            setReturnUser(false);
            //remove id and token from the URL
            let currentUrl = window.location.href;
            const newUrl = currentUrl.split('?')[0]; // Removes the query string (including id and token)
            // Update the URL without reloading the page
            window.history.replaceState(null, '', newUrl);

          } else if (quoteNum && quoteNum.trim() !== json.quoteId) {
            setErrors({});
            const newErrors = {}
            newErrors.quoteNum = "Invalid quote number.";
            setErrors(newErrors);
            return;
          }
          if (json.status === 'CONVERTED') {
            window.location.href = '/vehicle/converted';
          } else if (json.status === 'EXPIRED') {
            window.location.href = '/vehicle/expired';
          } else {
            // console.log(json);
            const queryParams = new URLSearchParams(window.location.search);
            const partnerId = queryParams.get('partnerId');
            props.handleChangeValue("regNumber", json.vehicle.regNumber);
            props.handleChangeValue("firstName", json.applicant.firstName);
            props.handleChangeValue("lastName", json.applicant.lastName);

            if (undefined !== json.quoteId && json.quoteId !== '' && json.quoteId !== null) {
              props.handleChangeValue("quoteNumber", json.quoteId);
              // console.log("json.vehicleDetails.isFinanced", json.vehicleDetails.isFinanced);
              if ((partnerId === 'Simplify') && (undefined !== json.vehicleDetails.isFinanced && null != json.vehicleDetails.isFinanced)) {
                props.handleChangeValue("isFinanced", 'YES');
                props.handleChangeValue("financeCompany", json.vehicleDetails.financeCompany);
              } else if ((partnerId !== 'Quashed' && partnerId !== 'Simplify') || (undefined !== json.vehicleDetails.isFinanced && null != json.vehicleDetails.isFinanced)) {
                props.handleChangeValue("businessUse", 'NO');
                props.handleChangeValue("modification", 'NO');
                props.handleChangeValue("isCriminalRecord", "NO");
              }
              if ((partnerId !== 'Quashed' && partnerId !== 'Simplify') || (undefined !== json.vehicleDetails.isFinanced && null != json.vehicleDetails.isFinanced)) {
                if (undefined === json.vehicleDetails.financeCompany || !json.vehicleDetails.financeCompany) {
                  props.handleChangeValue("isFinanced", 'NO');
                } else {
                  props.handleChangeValue("isFinanced", 'YES');
                  props.handleChangeValue("financeCompany", json.vehicleDetails.financeCompany);
                }
              }
              // let addressline2 = json.addressDetails.addressInFreeForm.addressLine2 !== '' && undefined !== json.addressDetails.addressInFreeForm.addressLine2 ? ', ' + json.addressDetails.addressInFreeForm.addressLine2 : '';
              const riskAddress = json.addressDetails.find(address => address.type === "RISK");
              if (riskAddress) {
                setRiskAddress(riskAddress);
                setLocalRiskAddress(riskAddress);
                callAddressSearch(riskAddress.addressInFreeForm.addressLine1, riskAddress.addressInFreeForm.addressLine2, riskAddress.suburb, riskAddress.postcode);
              }
              const postalAddress = json.addressDetails.find(address => address.type === "POSTAL")
              if (postalAddress) {
                setPostalAddress(postalAddress)
              }
              props.handleChangeValue("postcode", riskAddress.postcode);
              props.handleChangeValue("suburb", riskAddress.suburb);

              const driverList = {...props.inputValues.driverList};
              // console.log("json.drivers", json.drivers);
              json.drivers.forEach((driver, index) => {
                const driverKey = `driver${index + 1}`;
                driverList[driverKey] = {
                  ...driverList[driverKey],
                  firstName: driver.givenName,
                  lastName: driver.surname,
                  dateOfBirth: driver.dateOfBirth,
                  type: driver.type,
                  incidentCount: (driver.incidentCount !== undefined && driver.incidentCount !== null) ? driver.incidentCount.toString() : '',
                  incidentList: mapIncidentList(driver)
                };
              });
              props.handleChangeValue("driverList", driverList);
              props.handleChangeValue('driverLength', json.drivers.length);
              const policyholderList = {...props.inputValues.policyHolderList};
              json.policyHolderDetails.forEach((policyholder, index) => {
                const policyholderKey = `policyHolder${index + 1}`;
                policyholderList[policyholderKey] = {
                  ...policyholderList[policyholderKey],
                  firstName: policyholder.firstName,
                  lastName: policyholder.lastName,
                  dateOfBirth: policyholder.dateOfBirth,
                  title: policyholder.title,
                  email: policyholder.email,
                  mobileCode: policyholder.mobile.substring(0, 3), // Extracting the first 3 digits
                  mobile: policyholder.mobile.substring(3)        // Extracting the remaining digits
                };
              });
              if (json.policyHolderDetails && json.policyHolderDetails.length > 0) {
                props.handleChangeValue("policyHolderLength", json.policyHolderDetails.length);
              } else {
                props.handleChangeValue("policyHolderLength", 1);
                policyholderList[`policyHolder1`] = {
                  firstName: '',
                  lastName: '',
                  dateOfBirth: '',
                  title: '',
                  mobileCode: '021',
                  mobile: '',
                  email: ''
                };
              }
              props.handleChangeValue("policyHolderList", policyholderList);
              await handleTransmissionChange(json.vehicle.regNumber, json.vehicleDetails.transmission)
              if ((partnerId !== 'Quashed' && partnerId !== 'Simplify') || (undefined !== json.vehicleDetails.isFinanced && null != json.vehicleDetails.isFinanced)) {
                await vehicleSumInsured(json.vehicleDetails.vehicleKey);
              }
              const dateOfBirth = json.drivers[0].dateOfBirth;
              const formattedDob = formatDate(dateOfBirth);

              fetch(url + '/vero/quote/retrieve', {
                method: "POST",
                mode: "cors",
                headers: new Headers({
                  "Content-Type": "application/json",
                  "Authorization": `Bearer ${jwt}`
                }),
                body: JSON.stringify(
                  {
                    "attributes": {
                      "insuredDetails": {
                        "customerDob": formattedDob,
                        "customerPostcode": riskAddress.postcode
                      },
                      "quoteNumber": json.quoteId
                    },
                    "type": "string"
                  }
                )
              })
                .then(response => response.json())
                .then(data => {
                  // console.log("JSON.stringify(data)", JSON.stringify(data));

                  const policyComponent = data.data.attributes.policyComponent;
                  const coverages = policyComponent?.coverages?.[0]?.compensations || [];
                  const windscreenExcessWaiver = coverages.find(comp => comp.compensationSubType === "WindscreenExcessWaiver");
                  const hireCar = coverages.find(comp => comp.compensationSubType === "HireCar");
                  const roadsideAssist = coverages.find(comp => comp.compensationSubType === "RoadsideAssist");

                  props.handleChangeValue('insuranceCover', policyComponent.coverages[0].policyCoverType);
                  props.handleChangeValue('excessFreeWindow', windscreenExcessWaiver ? windscreenExcessWaiver.appliedIndicator : false);
                  props.handleChangeValue('hireCar', hireCar ? (hireCar.code !== 'NOT_TAKEN') : false);
                  props.handleChangeValue('roadSideAssistance', roadsideAssist ? roadsideAssist.appliedIndicator : false);
                  props.handleChangeValue('excess', policyComponent.coverages[0].voluntaryExcess);
                  props.handleChangeValue('paymentFrequency', data.data.attributes.policyDetails.billingInfo.frequency);
                  props.handleChangeValue('premium', data.data.attributes.policyComponent.premium.installmentAmount);
                  if ((partnerId === 'Quashed' || partnerId === 'Simplify') && policyComponent.coverages[0].policyCoverType === "THIRD_PARTY") {
                    props.handleChangeValue("vehicleValue", '');
                  } else {
                    props.handleChangeValue("vehicleValue", json.vehicleDetails.value);
                  }


                  const policyHistory = data.data.attributes.policyDetails.policyHistory;
                  const lastModifiedDatetime = policyHistory.lastModifiedDatetime;
                  const lastModifiedUserId = policyHistory.lastModifiedUserId;

                  const response = {
                    data: {
                      attributes: {
                        policyDetails: {
                          policyHistory: {
                            lastModifiedDatetime: lastModifiedDatetime,
                            lastModifiedUserId: lastModifiedUserId
                          },
                          quoteNum: json.quoteId
                        }
                      }
                    }
                  };
                  props.handleChangeValue('responseJson', JSON.stringify(response));
                  let back = searchParams.get("back");
                  if (back && back === 'yes') {
                    props.policyHolderStep();
                  }
                })
                .catch(error => console.log('Error:', error));
            }
          }
        });

      })
      .catch((err) => {
        const newErrors = {}

        newErrors.quoteNum = "Invalid quote number.";
        setErrors(newErrors);
      });
  }

  const riskAddress = (e) => {
    setRiskAddressList({});
    if (riskAddressList.suggestedAddresses.length > 1) {
      riskAddressList.suggestedAddresses.map(address => {
        if (address.addressId === e.target.value) {
          let addressline2 = address.addressInFreeForm.addressLine2 != '' && address.addressInFreeForm.addressLine2 != undefined ? ', ' + address.addressInFreeForm.addressLine2 : '';
          props.handleChangeValue('full_address', address.addressInFreeForm.addressLine1 + addressline2 + ', ' + address.suburb + ', ' + address.postcode);
          callAddressSearch(address.addressInFreeForm.addressLine1, address.addressInFreeForm.addressLine2, address.suburb, address.postcode);

        }
      })
    } else {
      riskAddressList.suggestedAddresses.map(address => {
        setRiskAddress(address);
      })
    }

  }
  const callAddressSearch = async (addressLine1, addressLine2, suburb, postCode, nonUniqueAddress) => {
    setAddressParams({addressLine1, addressLine2, suburb, postCode, nonUniqueAddress});
    setLoadingAddress(true);
    if (!executeRecaptcha) {
      console.log('reCAPTCHA is not ready');
      return;
    }
    let token = await executeRecaptcha('submit');
    if (props.inputValues.isRecaptchaV2Verified) {
      token = "AUTHENTICATED_V2"
    }
    let jwt = Cookies.get('jwt-token');
    fetch(url + '/vero/address/risk', {
      method: "POST",
      mode: "cors",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${jwt}`
      }),
      body: JSON.stringify({
        "addressInFreeForm": {
          "addressLine1": addressLine1,
          "addressLine2": addressLine2
        },
        "postcode": postCode,
        "suburb": suburb,
        "recaptchaResponse": token
      })
    })
      .then((response) => {
        if (response.status === 428) {
          // Show fallback captcha for 428 status
          console.log('Primary reCAPTCHA failed for riskAddress, showing fallback captcha');
          //setIsSubmitting(false);
          props.handleChangeValue("showRecaptchaPopup", true);
          setVerificationFailedStep(prev => [...prev, "callAddressSearch"]);
          return;
        }

        if (!response.ok) {
          setLoadingAddress(false);
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        setLoadingAddress(false);
        return response.text(); // Try to get the response as text first
      })
      .then((text) => {
        const newErrors = {};
        setErrors(newErrors);
        if (text) {
          const json = JSON.parse(text); // Parse it only if there's valid text
          // console.log("response.json() address", json);
          setShowNoAddressBlock(false);
          if (nonUniqueAddress) {
            setRiskAddressList([]);
          }
          // setUniqueAddressFound(false);
          props.handleChangeValue('uniqueAddressFound', false);

          if (json.data.attributes.suggestedAddresses.length === 0) {
            setAddressSearchComplete(false);
            setRiskAddressList([]);
            props.handleChangeValue('postcode', '');
            setShowNoAddressBlock(true);
          } else if (json.data.attributes.status === 'SUGGESTED' && json.data.attributes.suggestedAddresses.length === 1) {
            setRiskAddress(json.data.attributes.suggestedAddresses[0]);
            setAddressSearchComplete(false);
            // setUniqueAddressFound(true);
            props.handleChangeValue('uniqueAddressFound', true);

          } else if (json.data.attributes.status === 'SUGGESTED' && json.data.attributes.suggestedAddresses.length !== 1) {
            setRiskAddressList(json.data.attributes);
            setAddressSearchComplete(true);
          }
        } else {
          throw new Error("Empty response from the server");
        }
      })
      .catch((err) => {
        console.error("Caught error: ", err);
        const newErrors = {};
        newErrors.address = "Address not found.";
        setErrors(newErrors);
        props.handleChangeValue('addressLine1', '');
        props.handleChangeValue('addressLine2', '');
        props.handleChangeValue('suburb', '');
        props.handleChangeValue('city', '');
        props.handleChangeValue('postcode', '');
      });
  };


  const setRiskAddress = (address) => {
    props.handleChangeValue("riskAddressId", address.addressId);
    props.handleChangeValue("riskPostcode", address.postcode);
    props.handleChangeValue("riskSignature", address.signature);
    props.handleChangeValue("riskSuburb", address.suburb);
    props.handleChangeValue('postcode', address.postcode);
    props.handleChangeValue('suburb', address.suburb);
    if (address.addressInBrokenDownForm !== undefined) {
      props.handleChangeValue("riskBuildingName", address.addressInBrokenDownForm.buildingName);
      props.handleChangeValue("riskLevelNumber", address.addressInBrokenDownForm.levelNumber);
      props.handleChangeValue("riskLevelType", address.addressInBrokenDownForm.levelType);
      props.handleChangeValue("riskStreetName", address.addressInBrokenDownForm.streetName);
      props.handleChangeValue("riskStreetNumber", address.addressInBrokenDownForm.streetNumber);
      props.handleChangeValue("riskStreetSuffixCode", address.addressInBrokenDownForm.streetSuffixCode);
      props.handleChangeValue("riskStreetType", address.addressInBrokenDownForm.streetType);
      props.handleChangeValue("riskUnitNumber", address.addressInBrokenDownForm.unitNumber);
      props.handleChangeValue("riskUnitType", address.addressInBrokenDownForm.unitType);
    }
    props.handleChangeValue("riskAddressLine1", address.addressInFreeForm.addressLine1);
    props.handleChangeValue("riskAddressLine2", address.addressInFreeForm.addressLine2);
    let addressline2 = address.addressInFreeForm.addressLine2 != '' && address.addressInFreeForm.addressLine2 != undefined ? ', ' + address.addressInFreeForm.addressLine2 : '';
    props.handleChangeValue('full_address', address.addressInFreeForm.addressLine1 + addressline2 + ', ' + address.suburb + ', ' + address.postcode);
  }
  const setPostalAddress = (address) => {
    props.updatePostalAddress("postalAddress.addressId", address.addressId);
    props.updatePostalAddress("postalAddress.postcode", address.postcode);
    props.updatePostalAddress("postalAddress.signature", address.signature);
    props.updatePostalAddress("postalAddress.suburb", address.suburb);
    if (address.addressInBrokenDownForm !== undefined) {
      props.updatePostalAddress("postalAddress.buildingName", address.addressInBrokenDownForm.buildingName);
      props.updatePostalAddress("postalAddress.levelNumber", address.addressInBrokenDownForm.levelNumber);
      props.updatePostalAddress("postalAddress.levelType", address.addressInBrokenDownForm.levelType);
      props.updatePostalAddress("postalAddress.streetName", address.addressInBrokenDownForm.streetName);
      props.updatePostalAddress("postalAddress.streetNumber", address.addressInBrokenDownForm.streetNumber);
      props.updatePostalAddress("postalAddress.streetSuffixCode", address.addressInBrokenDownForm.streetSuffixCode);
      props.updatePostalAddress("postalAddress.streetType", address.addressInBrokenDownForm.streetType);
      props.updatePostalAddress("postalAddress.unitNumber", address.addressInBrokenDownForm.unitNumber);
      props.updatePostalAddress("postalAddress.unitType", address.addressInBrokenDownForm.unitType);
    }
    props.updatePostalAddress("postalAddress.addressLine1", address.addressInFreeForm.addressLine1);
    props.updatePostalAddress("postalAddress.addressLine2", address.addressInFreeForm.addressLine2);
    let addLine2 = (address.addressInFreeForm.addressLine2 != undefined && address.addressInFreeForm.addressLine2 != '') ? ',' + address.addressInFreeForm.addressLine2 : '';

    props.updatePostalAddress('postalAddress.fullAddress', address.addressInFreeForm.addressLine1 + addLine2 + ', ' + address.suburb + ', ' + address.postcode);

  }
  const vehicleSumInsured = async (vehicleKey) => {
    if (!executeRecaptcha) {
      console.log('reCAPTCHA is not ready');
      return;
    }
    let token = await executeRecaptcha('submit');
    if (props.inputValues.isRecaptchaV2Verified) {
      token = "AUTHENTICATED_V2"
    }
    let jwt = Cookies.get('jwt-token');
    props.handleChangeValue("vehicleKey", vehicleKey);
    setVehicleKey(vehicleKey);
    // Find the variant object where vehicleKey matches e.target.value
    const selectedVariant = props.inputValues.modelList.find(variant => variant.vehicleKey === vehicleKey);
    const model = selectedVariant ? selectedVariant.vehicleDescription : '';
    props.handleChangeValue("vehicleModel", model);
    fetch(url + '/vero/vehicle/suminsured', {

      method: "POST",
      mode: "cors",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${jwt}`
      }),
      body: JSON.stringify(
        {
          "vehicleKey": vehicleKey,
          "recaptchaResponse": token
        })
    })
      .then((response) => {
        if (response.status === 428) {
          // Show fallback captcha for 428 status
          console.log('Primary reCAPTCHA failed for vehicleSumInsured, showing fallback captcha');
          //setIsSubmitting(false);
          props.handleChangeValue("showRecaptchaPopup", true);
          setVerificationFailedStep(prev => [...prev, "vehicleSumInsured"]);

          return;
        }
        response.json().then((json) => {
          props.handleChangeValue('vehicleMinValue', json.minSumInsured);
          props.handleChangeValue('vehicleMaxValue', json.maxSumInsured);
          setSumInsuredRange(" $" + json.minSumInsured.toLocaleString() + " and $" + json.maxSumInsured.toLocaleString() + " ");
        });
      })
      .catch((err) => console.error("Caught error: ", err));

  }

  const currencyFormat = (num) => {
    if (num === '') {
      return '';
    }
    let vv = parseFloat(num);

    return (vv).toLocaleString('en-US', {
      style: 'currency', currency: 'USD',
    }).replace('.00', '');

  }
  const handleTransmissionChange = async (regNumber, transmissionType) => {
    props.handleChangeValue("vehicleModel", '');
    props.handleChangeValue("transmissionType", transmissionType);
    setLoadingModels(true); // Set loading state to true
    await vehicleLookup(regNumber, transmissionType); // Fetch models based on transmission type
  }
  const vehicleLookup = async (regNumber, transmissionType) => {
    setVehicleLookupParam({regNumber, transmissionType});
    if (!executeRecaptcha) {
      console.log('reCAPTCHA is not ready');
      return;
    }
    // Execute reCAPTCHA and get the token
    let token = await executeRecaptcha('submit'); // 'submit' is your custom action name
    if (props.inputValues.isRecaptchaV2Verified) {
      token = "AUTHENTICATED_V2"
    }
    let jwt = Cookies.get('jwt-token');
    while (!jwt || jwt === 'undefined' || jwt === '') {
      console.log("JWT token not available. Waiting...");
      await new Promise(resolve => setTimeout(resolve, 1000)); // Wait for 1 second before checking again
      jwt = Cookies.get('jwt-token');
    }

    try {
      const response = await fetch(url + '/vero/vehiclelookup', {
        method: "POST",
        mode: "cors",
        headers: new Headers({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${jwt}`
        }),
        body: JSON.stringify({
          "registrationOrVin": regNumber,
          "transmission": transmissionType,
          "recaptchaResponse": token
        })
      });
      if (response.status === 428) {
        // Show fallback captcha for 428 status
        console.log('Primary reCAPTCHA failed for vehicle lookup, showing fallback captcha');
        props.handleChangeValue("transmissionType", "");
        //setIsSubmitting(false);
        props.handleChangeValue("showRecaptchaPopup", true);
        //setVerificationFailedStep(prev => [...prev, "vehicleLookup"]);
        return;
      }
      const json = await response.json();
      const newErrors = {};
      setErrors(newErrors);
      if (json.results && json.results.length > 0) {
        props.handleChangeValue("modelList", json.results);
        setModelList(json.results);

        window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': `${eventName}`,
            'category': 'Model Found',
            'status': 'Success',
            'virtualUrl': `${baseUrl}/vehicle/step1`,
            'pageTitle': 'Car',
          });

      } else {
        console.log("empty modelList", props);
        newErrors.transmissionType = "Could not find vehicle. Please check details and try again. If the issue persists please contact Vero on 0800 288 787 for further assistance.";
        props.handleChangeValue("modelList", []);

        window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': `${eventName}`,
            'category': 'Model Found',
            'status': 'Fail',
            'virtualUrl': `${baseUrl}/vehicle/step1`,
            'pageTitle': 'Car',
          });

      }
    } catch (err) {
      console.error("Caught error: ", err);
    } finally {
      setLoadingModels(false); // Turn off loading state regardless of success or failure
    }
  };

  function extractParams(inputString) {
    const queryString = inputString.split('?')[1];
    const paramsArray = queryString.split('&');
    const params = {};
    paramsArray.forEach(param => {
      const [key, value] = param.split('=');
      params[key] = value;
    });
    return params;
  }

  const handleChangeVehicleValue = (e) => {
    props.handleChangeValue("vehicleValue", e.target.value.replaceAll("$", "").replaceAll(",", "").trim());
  }

  const getSource = () => {
    const hostname = window.location.hostname.toLowerCase();
    const map = {
      quashed: "Quashed",
      better: "BetterFinance",
      loanplace: "Loanplace",
      simplify: "Simplify",
      car: "Autosure",
      localhost: "Simplify"
    };
    // check if hostname contains a known key
    const key = Object.keys(map).find((k) => hostname.includes(k));
    return key ? map[key] : null;
  };

  const handleRegistrationNumberChange = (e) => {
    // Remove all spaces from the input value
    const valueWithoutSpaces = e.target.value.replace(/\s/g, '');
    setRegistrationNumber(valueWithoutSpaces);
    props.handleChangeValue("modelList", []);
    props.handleChangeValue("vehicleModel", '');
    props.handleChangeValue("transmissionType", '');
    props.handleChangeValue("vehicleKey", '');
    setLoadingModels(false);
    props.handleChangeValue("regNumber", valueWithoutSpaces);
    // Update the input field value to reflect the change
    e.target.value = valueWithoutSpaces;
  };
  const createProspect = async (e) => {
    if (nztaUnavailable) return;
    setErrors({});
    setLoading(true);
    const reg = props.inputValues.regNumber && props.inputValues.regNumber.trim() !== '' ? props.inputValues.regNumber : registrationNumber;
    if (!executeRecaptcha) {
      console.log('reCAPTCHA is not ready');
      return;
    }
    let token = await executeRecaptcha('submit');
    if (props.inputValues.isRecaptchaV2Verified) {
      token = "AUTHENTICATED_V2"
    }
    try {
      const queryParams = new URLSearchParams();
      const response = await fetch(`${url}/campaign/policy-renewal/secure/vehicleDetails/${reg}`, {
        method: 'GET',
        mode: "cors",
        headers: {
          'Content-Type': 'application/json',
          "Authorization": 'By-Pass-Auth-Create-Prospect',
          "captchaRequest": token
        }
      });

      const source = getSource();

      console.log('source', source);

      if (response.status === 428) {
        // Show fallback captcha for 428 status
        console.log('Primary reCAPTCHA failed for createProspect, showing fallback captcha');
        //setIsSubmitting(false);
        props.handleChangeValue("showRecaptchaPopup", true);
        setVerificationFailedStep(prev => [...prev, "createProspect"]);
      } else if (response.ok && response.status === 200) {

        let newToken = await executeRecaptcha('submit');
        if (props.inputValues.isRecaptchaV2Verified) {
          newToken = "AUTHENTICATED_V2"
        }
        const prospectData = {
          email: '',
          mobilePhone: '',
          registrationNumber: reg,
          firstName: '',
          lastName: '',
          "recaptchaResponse": newToken,
          source: source
        };
        try {
          const response = await fetch(`${url}/vero/prospect/registration`, {
            method: 'POST', mode: "cors", headers: {
              'Content-Type': 'application/json', "Authorization": 'By-Pass-Auth-Create-Prospect'
            },
            body: JSON.stringify(prospectData),
          });
          if (response.ok) {
            if (response.status === 200) {
              const responseData = await response.json();
              setURLSource(responseData.source);
              const params = extractParams(responseData.url);
              let token = params.token;
              let renewalId = params.id;
              var details = {
                'user_id': renewalId, 'password': token,
              };

              if (token == null) {
                let renewalId = searchParams.get("id");
                let jwt = Cookies.get('jwt-token');
                if (jwt != null) {
                  getVehicleDetails(jwt, renewalId);
                  return;
                }
              }
              var formBody = "?";
              for (var property in details) {
                var encodedKey = encodeURIComponent(property);
                var encodedValue = encodeURIComponent(details[property]);
                formBody += (encodedKey + "=" + encodedValue + '&');
              }
              fetch(url + '/login' + formBody, {

                method: 'POST', mode: "cors", headers: {
                  'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                }, body: formBody
              })
                .then((response) => {
                  if (!response.ok) {
                    throw new Error('Network response was not ok');
                  }
                  response.json().then((json) => {
                    //setCookie('jwt-token', json.jwt, {path: '/'});
                    props.handleChangeValue('sessionTimeout', props.inputValues.sessionTimeout + 1);
                    setCookie('jwt-token', json.JWT, {
                      path: '/',
                      maxAge: props.inputValues.sessionTimeout
                    });
                    let jwt = Cookies.get('jwt-token');
                    getVehicleDetails(jwt, renewalId);

                  });
                })
                .catch((err) => {
                  console.error("Caught error: ", err);
                  window.location.href = '/turners/page-not-found';  // Update the path as needed
                });
            }
          } else {
            console.error('Failed to create prospect. Status Code:', response.status);
          }
        } catch (error) {
          console.error('An error occurred:', error);
        }
      } else {
        const newErrors = {}
        setErrors(newErrors);
        newErrors.registrationNumber = "Please enter a valid plate number";
      }
    } catch
      (error) {
      console.error('An error occurred:', error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error('Response status:', error.response.status);
        console.error('Response data:', error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        console.error('No response received:', error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error('Error setting up the request:', error.message);
      }
      setContinueOfflinePopupShow(true);
    } finally {
      setLoading(false);
    }
  };
  const handleNewQuoteClick = () => {
    window.location.href = '/vehicle';
  };
  const handleRetrieveQuote = () => {
    let renewalId = searchParams.get("id");
    let jwt = Cookies.get('jwt-token');
    if (!quoteNum || quoteNum.trim() === '') {
      const newErrors = {};
      newErrors.quoteNum = "Quote number is required to proceed.";
      setErrors(newErrors);
      return;  // Stop execution if quoteNum is missing
    }
    getVehicleDetails(jwt, renewalId, quoteNum);
  }
  return (<>
    <br/><br/>
    {returnUser ? (
      <>  <br/> <br/><br/> <br/>
        <div style={{
          width: '100%',
          height: '100%',
          paddingTop: 20,
          justifyContent: 'space-between',

          display: 'flex',
        }}>
          <Container style={{height: "100%", minHeight: "55vh"}}>
            <div style={{flexDirection: 'column'}}>
              <h2>Welcome Back</h2><br/><br/>
              <div style={mediumTextStyles}>Enter the quote number from email to retrieve your quote
                <br/>
                <br/>
              </div>
              <div>
                <div style={regularTextStyles}>
                  Quote Number
                </div>
                <div style={{display: "flex", gap: "10px"}}>
                  <input type="text" name="quoteNum" id="quoteNum" value={quoteNum}
                         onChange={e => setQuoteNum(e.target.value)}/>
                  <br/>
                </div>
                {errors.quoteNum && (
                  <div style={regularErrorStyle}>{errors.quoteNum}</div>
                )}
                <div style={{paddingBottom: "1rem"}}></div>
                <button
                  style={{
                    color: "white",
                    paddingLeft: 25,
                    paddingRight: 25,
                    paddingTop: 13,
                    paddingBottom: 13,
                    width: "100%",
                    maxWidth: "200px",
                    background: '#1851A3',
                    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                    borderRadius: 6,
                    overflow: 'hidden',
                    border: '1px white solid',
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'inline-flex',
                    cursor: 'pointer',
                  }}
                  onClick={handleRetrieveQuote}
                >
                  Retrieve your quote
                </button>
              </div>

              <div style={{paddingTop: '2rem'}}>Can’t find your details? <span style={{
                color: '#1851A3', textDecoration: "underline",
                cursor: "pointer",
              }} onClick={handleNewQuoteClick}>Start a new quote</span>
              </div>
            </div>
          </Container></div>
      </>
    ) : (<>
      <Row className="justify-content-center">
        <NavigateCarInsurance steps={steps}/>
      </Row>
      <div className="lg-car-padding sm-car-padding">
        <div>
          <div style={{paddingBottom: "50px", paddingTop: "20px"}}>
            <div style={regularTextStyles}>Vero's decision to insure you is based on the information you
              provide. This includes the terms that are applied and the premium that is charged. It is
              very
              important that your answers to questions are correct and complete. If they are not, you may
              not
              have cover if you have a claim. Your policy might also be avoided, which means it is treated
              as
              if it never existed. This could make it difficult to get insurance in the future.
            </div>
          </div>
          <div style={{display: "flex", flexDirection: "column"}}>
            <div style={{paddingBottom: "40px"}}>
              <div style={{display: "flex", flexDirection: "column"}}>
                <div style={boldTextStyles}>
                  Enter your car’s number plate
                </div>
                <div style={{display: "flex", gap: "10px"}}>
                  <Form.Control
                    type="text"
                    placeholder="e.g. JHU968"
                    className={`block w-full rounded-md py-1.5 text-gray-900 shadow-sm placeholder:text-gray-400 ${isFocused ? 'focus-blue' : ''}`}
                    name="registrationNumber"
                    maxLength={6}
                    defaultValue={props.inputValues.regNumber}
                    onChange={(event) => {
                      event.target.value = event.target.value.toUpperCase();
                      handleRegistrationNumberChange(event);
                    }}
                    required={true}
                    style={{
                      fontFamily: 'Lato', fontSize: 14, fontWeight: 400, width: '100%',
                      maxWidth: '300px'
                    }}
                    onFocus={() => setIsFocused(true)}
                    onBlur={(event) => {
                      const trimmedValue = event.target.value.trim();
                      if (trimmedValue !== '') {
                        createProspect();
                      }
                    }}
                  />
                </div>
                {errors.registrationNumber && !nztaUnavailable && (
                  <div style={regularErrorStyle}>{errors.registrationNumber}</div>
                )}
                {nztaUnavailable && (registrationNumber || props.inputValues.regNumber) && (
                  <div style={regularErrorStyle}>The NZTA service is temporarily unavailable, so we cannot search for your vehicle. Please try again later. Thank you for your patience.</div>
                )}
              </div>
            </div>
            <div style={{paddingBottom: "40px"}}>
              <div style={{display: "flex", flexDirection: "column",}}>
                <div style={boldTextStyles}>
                  Transmission
                </div>
                <div>
                  <div style={{display: "flex", alignItems: "center", paddingTop: "10px"}}>
                    <Form.Check
                      type="radio"
                      name="transmissionType"
                      label="Automatic"
                      style={regularTextStyles}
                      className="custom-radio"
                      id="Automatic"
                      value="Automatic"
                      checked={props.inputValues.transmissionType === 'Automatic'}
                      onChange={(e) => handleTransmissionChange(props.inputValues.regNumber, "Automatic")}
                      disabled={!props.inputValues.regNumber}
                    />
                    &emsp;&emsp;&emsp;&emsp;
                    <Form.Check
                      type="radio"
                      name="transmissionType"
                      label="Manual"
                      style={regularTextStyles}
                      className="custom-radio"
                      id="Manual"
                      value="Manual"
                      checked={props.inputValues.transmissionType === 'Manual'}
                      onChange={(e) => handleTransmissionChange(props.inputValues.regNumber, "Manual")}
                      disabled={!props.inputValues.regNumber}
                    />
                  </div>
                  {errors.transmissionType && (
                    <div style={regularErrorStyle}>{errors.transmissionType}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {loadingModels && !props.inputValues.showRecaptchaPopup && (
            <div
              style={{
                position: "fixed",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(255, 255, 255, 0.8)", // Semi-transparent background
                zIndex: 9999, // Ensure it appears above other content
                overflow: "hidden", // Prevent scrolling
                pointerEvents: "none", // Disable user interactions
              }}
            >
              <div style={{textAlign: "center", pointerEvents: "all"}}>
                <Spinner
                  animation="border"
                  style={{width: "100px", height: "100px"}} // Larger spinner size
                />
                <div>We’re finding your car’s model…</div>
              </div>
            </div>
          )}
          {(props.inputValues.modelList.length > 0 || props.inputValues.vehicleModel !== '') && !loadingModels && (
            <div style={{paddingBottom: "40px"}}>
              <span style={boldTextStyles}> Model </span>
              <div style={{paddingTop: "10px"}}>
                {
                  props.inputValues.modelList.map((variant, idx) =>
                    <Form.Check
                      key={variant.vehicleKey}
                      type="radio"
                      label={variant.vehicleDescription}
                      style={regularTextStyles}
                      className="custom-radio"
                      id={`variant${idx}`}
                      name="variant"
                      value={variant.vehicleKey}
                      onChange={() => vehicleSumInsured(variant.vehicleKey)}
                      checked={props.inputValues.vehicleKey === variant.vehicleKey}
                      addressType="risk"
                    />
                  )
                }
              </div>
              {errors.vehicleKey && (
                <div style={regularErrorStyle}>{errors.vehicleKey}</div>
              )}
            </div>
          )}
          {(props.inputValues.modelList.length > 0 || props.inputValues.vehicleModel !== '') && !loadingModels && (<>
          <div style={{paddingBottom: "40px"}}>
            <div style={{paddingBottom: "10px"}}>
                            <span
                              style={boldTextStyles}>Will you use this car to earn any income?</span>
              <TooltipTFAF
                title={
                  <div>
                    <div>Select ‘No’ if you drive your car to and from work and/or occasionally use in connection with
                      work or if used for volunteer work.
                    </div>
                    <br/>
                    <div>Select 'Yes' if you drive your car for the purpose of earning income, e.g. trades person,
                      courier, taxi/Uber, driving instructor or courtesy vehicle.
                    </div>
                  </div>
                }>
                <i className="fa fa-info-circle" style={{color: '#1851A3'}}/>
              </TooltipTFAF>
            </div>
            <div style={{display: "flex", alignItems: "center", gap: "115px"}}>
              <Form.Check
                type="radio"
                name="isBusiness"
                label="Yes"
                style={regularTextStyles}
                className="custom-radio"
                id="businessYes"
                checked={props.inputValues.businessUse === 'YES'}
                onChange={() => {
                  props.handleChangeValue("businessUse", "YES");
                  setContinueOfflinePopupShow(true);
                }}
              />
              <Form.Check
                type="radio"
                name="isBusiness"
                label="No"
                style={regularTextStyles}
                className="custom-radio"
                id="businessNo"
                checked={props.inputValues.businessUse === 'NO'}
                onChange={() => {
                  props.handleChangeValue("businessUse", "NO");
                  setContinueOfflinePopupShow(false);
                }}
              />
            </div>
            {errors.businessUse && (
              <div style={regularErrorStyle}>{errors.businessUse}</div>
            )}
          </div>
          <div style={{paddingBottom: "40px"}}>
            <div style={{paddingBottom: "10px"}}>
              <span style={boldTextStyles}>Does your car have any of the following modifications?</span>
              <TooltipTFAF
                title={
                  <div>
                    Please select 'Yes' if your car has had any of the listed modifications made to it after it was
                    originally manufactured.
                  </div>
                }>
                <i className="fa fa-info-circle" style={{color: '#1851A3'}}/>
              </TooltipTFAF>
            </div>
            <ul style={regularTextStyles}>
              <li>Suspension changes, gearbox upgrade and 2WD & 4WD conversions</li>
              <li>Turbo, supercharger, internal engine modifications, nitro fuel, external
                wastegate
                and boost controller
              </li>
              <li>Panel changes, custom or specialised paint and vinyl wrap</li>
              <li>Roll bar or cage, racing harness, scissor or gull wing doors or shaved handles</li>
            </ul>
            <div style={{display: "flex", alignItems: "center", gap: "110px"}}>
              <Form.Check
                type="radio"
                label="Yes"
                style={regularTextStyles}
                className="custom-radio"
                id="modifiedYes"
                name="isModified"
                checked={props.inputValues.modification === 'YES'}
                onChange={() => {
                  setContinueOfflinePopupShow(true);
                  props.handleChangeValue("modification", "YES");
                }}
              />
              <Form.Check
                type="radio"
                label="No"
                style={regularTextStyles}
                className="custom-radio"
                id="modifiedNo"
                name="isModified"
                checked={props.inputValues.modification === 'NO'}
                onChange={() => {
                  setContinueOfflinePopupShow(false);
                  props.handleChangeValue("modification", "NO");
                }}
              />
            </div>
            {errors.modification && (
              <div style={regularErrorStyle}>{errors.modification}</div>
            )}
          </div>
          <ContinueOfflinePopupTFAF2
            parentContinueOfflinePopupShow={continueOfflinePopupShow}
            setParentContinueOfflinePopupShow={setContinueOfflinePopupShow}
            parentModificationText={props.inputValues.modification}
          />
          <div style={{paddingBottom: "40px"}}>
            <div style={{paddingBottom: "10px"}}><span style={boldTextStyles}> Is your car financed?</span>
              <TooltipTFAF
                title="Finance can be a secured or unsecured loan, hire purchase or lease from a finance company, bank or credit union.">
                <i className="fa fa-info-circle" style={{color: '#1851A3'}}/>
              </TooltipTFAF>
            </div>
            <div style={{display: "flex", alignItems: "center", gap: "110px", paddingBottom: "10px"}}>
              <Form.Check
                type="radio"
                className="custom-radio"
                label="Yes"
                style={regularTextStyles}
                id="financedYes"
                checked={props.inputValues.isFinanced === "YES"}
                onChange={(e) => {
                  props.handleChangeValue("isFinanced", "YES");
                  handleFinanceOption(e);
                }}
              />
              <Form.Check
                type="radio"
                label="No"
                style={regularTextStyles}
                className="custom-radio"
                id="financedNo"
                checked={props.inputValues.isFinanced === "NO"}
                onChange={(e) => {
                  props.handleChangeValue("isFinanced", "NO");
                  handleFinanceOption(e);
                }}
              />
            </div>
            {errors.isFinanced && (
              <div style={regularErrorStyle}>{errors.isFinanced}</div>
            )}
            {props.inputValues.isFinanced === "YES" && (
              <div style={{paddingTop: "40px"}}>
                <p style={boldTextStyles}>Select your finance company:</p>
                <select
                  id="financeCompanySelect"
                  class="block w-full rounded-md py-1.5 pl-10 pr-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  style={{
                    border: '1px #E5E7EB solid',
                    boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                    borderRadius: 6,
                    width: '100%',
                    maxWidth: '300px',
                    outline: 'none',
                    lineHeight: 'inherit',
                    fontSize: '1rem', //16px
                    fontFamily: 'Lato',
                    fontWeight: '400',
                    wordWrap: 'break-word',
                    height: '40px',
                    marginRight: '10px',
                    background: 'transparent',
                  }}
                  value={Object.keys(financeCompanyCodes).find(key => financeCompanyCodes[key] === props.inputValues.financeCompany) || props.inputValues.financeCompany}
                  onChange={(e) => {
                    const selectedCompanyName = e.target.value;
                    const companyCode = financeCompanyCodes[selectedCompanyName];
                    props.handleChangeValue("financeCompany", companyCode || selectedCompanyName);
                  }}>
                  <option value="">Please select</option>
                  {financeCompanies.map(company => (
                    <option key={company} value={company}>{company}</option>
                  ))}
                </select>
                {errors.financeCompany && (
                  <div style={regularErrorStyle}>{errors.financeCompany}</div>
                )}
              </div>
            )
            }
          </div>
          <div style={{paddingBottom: "40px"}}>
            <div>
              <span style={boldTextStyles}>Address where your car is usually kept overnight</span>
              <TooltipTFAF
                title="The nearest address that you usually keep your car parked overnight – this can be on the road/street or for shift workers at your place of business.">
                <i className="fa fa-info-circle" style={{color: '#1851A3'}}/>
              </TooltipTFAF>
            </div>
            <div style={{display: "flex", flexDirection: "column", paddingTop: "10px"}}
                 className="column-on-mobile">
              <div>
                <PostalAddress
                  inputValues={props.inputValues}
                  errors={errors}
                  handleChange={props.handleChange}
                  handleChangeValue={props.handleChangeValue}
                  setErrors={setErrors}
                  callAddressSearch={callAddressSearch}
                  uniqueAddressFound={props.inputValues.uniqueAddressFound}
                  setUniqueAddressFound={setUniqueAddressFound}
                  fullAddress={props.inputValues.full_address}
                  fullAddressName="full_address"
                  updatePostalAddress={props.updatePostalAddress}
                />
                {loadingAddress && (


                  <div style={{textAlign: "left", pointerEvents: "all"}}>
                    <Spinner
                      animation="border"
                    />
                    <div>We’re finding your address…</div>
                  </div>
                )}
              </div>
            </div>
            {errors.address && (
              <div style={regularErrorStyle}>{errors.address}</div>
            )}
            <div>
              <div style={{paddingTop: "10px"}}>
                {addressSearchComplete && riskAddressList.suggestedAddresses != undefined ? riskAddressList.suggestedAddresses.map((riskAd, idx) =>
                  <Form.Check
                    type="radio"
                    label={riskAd.addressInFreeForm.addressLine1 + ", " + riskAd.suburb + " " + riskAd.postcode}
                    style={regularTextStyles}
                    className="custom-radio"
                    id={`suggestedAdd${idx}`}
                    name={`suggestedAdd${idx}`}
                    value={riskAd.addressId}
                    onChange={riskAddress}
                  />
                ) : <></>
                }
              </div>
            </div>
            <div>
              {showNoAddressBlock && <>
                <span style={{...regularErrorStyle, color: "red"}}>Address not found.</span>
              </>

              }
            </div>
          </div>


            <div style={{paddingBottom: "40px"}}>
                    <span style={boldTextStyles}>
                   Car’s value (amount covered)
                    </span>
            <TooltipTFAF
              title={
                <div>
                  <span>To help you set your car’s value, you could look at similar cars for sale online that are the same make, model, year, condition and mileage as yours.</span><br/><br/>
                  Please remember to allow for any additional improvements your car may have e.g. roof
                  racks and tow bars, fitted entertainment, communication and navigation systems.
                </div>
              }>
              <i className="fa fa-info-circle" style={{color: '#1851A3'}}/>
            </TooltipTFAF>
            <div style={{paddingTop: "10px"}}>
              <input
                type="text"
                class="block w-full rounded-md py-1.5 pl-10 pr-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                style={{
                  border: '1px #E5E7EB solid',
                  boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                  borderRadius: 6,
                  outline: 'none',
                  fontSize: 'inherit',
                  fontFamily: 'inherit',
                  fontWeight: 'inherit',
                  lineHeight: 'inherit',
                  width: '100%',
                  maxWidth: '300px',
                  height: '40px',
                  marginRight: '10px',
                  background: 'transparent',
                }}
                name="vehicleValue"
                onChange={handleChangeVehicleValue}
                maxLength={9}
                required={true}
                defaultValue={currencyFormat(props.inputValues.vehicleValue)}
                placeholder="$"
              />
            </div>

            {errors.vehicleValue && (
              <div style={regularErrorStyle}>{errors.vehicleValue}</div>
            )}
            <div style={regularTextStyles}><span>For Everyday Plus (Comprehensive) policies, the amount covered is the most we will pay for loss or damage to your car, less any excess or deductions that apply, and includes the value of accessories and modifications.
</span>
            </div>
            </div>
          </>)}
        </div>
        <div style={{paddingBottom: "150px"}}>
          <FormGroup>
            <button
              class="float-end"
              style={{
                color: "white",
                paddingLeft: 25,
                paddingRight: 25,
                paddingTop: 13,
                paddingBottom: 13,
                width: "100%",
                maxWidth: "200px",
                background: props.inputValues.businessUse === 'YES' || props.inputValues.modification === "YES" || props.inputValues.modelList.length === 0 ? '#B0C4DE' : '#1851A3',
                boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                borderRadius: 6,
                overflow: 'hidden',
                border: '1px white solid',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'inline-flex',
                cursor: 'pointer',
                opacity: 1
              }}
              onClick={handleNextButtonClick}
              disabled={props.inputValues.businessUse === 'YES' || props.inputValues.modification === "YES" || props.inputValues.modelList.length === 0}
            >
              Next
            </button>
            <br/>
            <br/>
          </FormGroup>
        </div>
      </div>
    </>)}
    {displayDisclosure && (
      <div>
        <DisclaimerPopup
          parentDeclarationPopupShow={declarationPopupShow}
          setParentDeclarationPopupShow={setDeclarationPopupShow}
          handleChangeValue={props.handleChangeValue}
        />
      </div>)}
  </>);
}
export default CarDetails;
